//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import Item from "../../../../Shortcode/Project/Item";
//Install
import Data from "../../../../Shortcode/Project/Data/Image";
//Install
import House from "../../../../Shortcode/Project/House/Image";
//Install
import Hotel from "../../../../Shortcode/Project/Hotel/Image";
//Install
import Water from "../../../../Shortcode/Project/Water/Image";
//Install
import Office from "../../../../Shortcode/Project/Office/Image";
//Install
import Formula from "../../../../Shortcode/Project/Formula/Image";
//Install
import Factory from "../../../../Shortcode/Project/Factory/Image";
//Install
import Hospital from "../../../../Shortcode/Project/Hospital/Image";
//Install
import Education from "../../../../Shortcode/Project/Education/Image";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Layihalar : Temas Elektrik Müqaviləsi"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik, Davamlı və Etibarlı Enerji Xidmətləri ilə Hər Toxunuş Gələcəyə Dəyər Qatar."
        //Element
        let URL = "https://temaselektrik.com/az/layihalar"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Gerçəkləşdirdiyimiz İşlər"
                                        )
                                    )
                                )
                            ),
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB c3937k" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Mənzil"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(House, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Orman Ada Konutları", Project: "280 ədəd Villa üçün Elektrik İşləri", Location: "İstanbul / Sarıyer", Date: "2013" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Holding", Project: "1 ədəd 6 mərtəbəli Yalı Binası", Location: "İstanbul / Yeniköy", Date: "2015" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Sinpaş Konutları", Project: "2 ədəd Villa Binası üçün Elektrik İşləri", Location: "İstanbul / Kilyos", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Öz Yazıcı İnşaat", Project: "İnfrastruktur və Ətraf İşıqlandırma", Location: "İstanbul / Kilyos", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Torunlar İnşaat", Project: "Zəif Cərəyan İnfrastruktur Kabelləşdirilməsi", Location: "İstanbul / Şişli", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Ceylan İnşaat", Project: "450 Mənzilli Yaşayış Binası Elektrik İşləri", Location: "Bolu", Date: "1999" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "TEOS Marin", Project: "11 Villa üçün İnfrastruktur və Ətraf İşıqlandırma", Location: "İstanbul / Şişli", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Aliç İnşaat", Project: "Ümumi Elektrik İşləri", Location: "İstanbul", Date: "2014" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Ticarət Obyekti"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Office, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Holding", Project: "Kanyon Ticarət Mərkəzi Ofis Mərtəbəsi", Location: "İstanbul / Yeniköy", Date: "2015" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Omak Mühendislik", Project: "Zorlu Ticarət Mərkəzi ZES Şarj Stansiyaları", Location: "İstanbul", Date: "2025" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Topkapı Karroser", Project: "Shell Yanacaqdoldurma Stansiyası Ofis Binası", Location: "İstanbul / Topkapı", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Vitra", Project: "120 nəfərlik Ofis Binası", Location: "İstanbul / Tuzla", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Spor", Project: "Ayazağa Quraşdırmaları", Location: "İstanbul / Maslak", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Kollektif House", Project: "40 Ofis / Ümumi Elektrik İşləri", Location: "İstanbul / Şişli", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Sosyal Yazılım", Project: "60 nəfərlik Çağrı Mərkəzi", Location: "İstanbul / Sanayi", Date: "2019" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Integral Medya", Project: "Şirkət Ofis Binası", Location: "İstanbul / Halkalı", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "5-ci Mərtəbə Tam Elektrik İşləri", Location: "İstanbul / Levent", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "250 nəfərlik Çağrı Mərkəzi", Location: "İstanbul / Kadıköy", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "Tam Elektrik İşləri", Location: "İstanbul / Ataşehir", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "Tam Elektrik İşləri", Location: "İstanbul / Şişli", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "Tam Elektrik İşləri", Location: "İzmir / Konak", Date: "2019" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Akvaryum AVM", Project: "Zəif Cərəyan Quraşdırılması", Location: "İstanbul / Florya", Date: "2011" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Kanyon AVM", Project: "Yaşayış Mərtəbələrinin Yenilənməsi", Location: "İstanbul / Levent", Date: "2013" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Divan Otel", Project: "Ofis Binası Elektrik İşləri", Location: "İstanbul / Ümraniye", Date: "2006" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "ANT Plato", Project: "Ümumi Ofis Binası İşləri", Location: "İstanbul", Date: "2022" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Farmalab", Project: "Kasımpaşa Mağazası", Location: "İstanbul", Date: "2022" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Swaroski", Project: "Kanyon Ticarət Mərkəzi Mağazası", Location: "İstanbul / Levent", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "İş Kule", Project: "Kantin Təmir İşləri", Location: "İstanbul / Levent", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "İşmer", Project: "Ümumi Elektrik İşləri", Location: "İstanbul", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "JUWO", Project: "Kanyon Ticarət Mərkəzi Mağazası", Location: "İstanbul / Levent", Date: "2019" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "H&M", Project: "3 Mərtəbəli Mağaza", Location: "İstanbul / Taksim", Date: "2010" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "H&M", Project: "3 Mərtəbəli Mağaza", Location: "İstanbul / Florya", Date: "2012" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Hotel"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Hotel, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Taş Ev Vilları", Project: "24 ədəd Daş Villa üçün Elektrik İşləri", Location: "İzmir / Çeşme", Date: "2003" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Otel", Project: "12 Otaqlı Daş Otel üçün Elektrik İşləri", Location: "İzmir / Çeşme", Date: "2002" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Xəstəxana"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Hospital, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Dokuz Eylül Hastanesi", Project: "7–8 Blok üçün Elektrik İşləri", Location: "İzmir / Balçova", Date: "1997" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Yeşilyurt Hıfzıssıhha H.", Project: "500 Yataqlı Xəstəxana Binası", Location: "İzmir / Yeşilyurt", Date: "1998" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Təhsil Müəssisələri"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Education, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Amerikan Robert Koleji", Project: "Fitness İdman Zalı", Location: "İstanbul / Etiler", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Amerikan Robert Koleji", Project: "Sosial Təsis Binası", Location: "İstanbul / Etiler", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "İnciraltı Öğrenci Yurdu", Project: "11 Bloklu Yurt Binası", Location: "İzmir / Balçova", Date: "1998" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Sabancı Üniversitesi", Project: "İdman Zalı Tikintisi", Location: "İstanbul / Tuzla", Date: "2004" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Güzelbahçe Lisesi", Project: "22 Dərslikli Məktəb Binası", Location: "İzmir / Güzelbahçe", Date: "1998" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Bornova Lisesi", Project: "26 Dərslikli Məktəb Binası", Location: "İzmir / Bornova", Date: "1998" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Fabrika"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Factory, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı İlaç Fabrikası", Project: "Fabrik Depolama Sahələri", Location: "İstanbul / Ayazağa", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Arslan Alüminyum", Project: "Fabrika Tikintisi", Location: "İstanbul / Beylikdüzü", Date: "2006" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Tofaş Fabrikası", Project: "Avtomatlaşdırma Panelləri", Location: "Bursa", Date: "2004" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Hafner Makine", Project: "Fabrika", Location: "İstanbul / Ayazağa", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Borusan Boru", Project: "Avtomatlaşdırma Panelləri", Location: "İzmit", Date: "2004" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "CMS Jant", Project: "Fabrika Tikintisi", Location: "İzmir / Çiğli", Date: "2005" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Arçelik", Project: "Avtomatlaşdırma Panelləri", Location: "Bolu", Date: "2005" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Vestel", Project: "Avtomatlaşdırma Panelləri", Location: "Manisa", Date: "2005" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "B/S/H", Project: "Avtomatlaşdırma Panelləri", Location: "Tekirdağ / Çerkezköy", Date: "2005" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Formula 1"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Formula, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Divan", Project: "Formula Qran Pri", Location: "İstanbul / Tuzla", Date: "2007" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Şəbəkə / Məlumat"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Data, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "NETAŞ Fatih Projesi", Project: "8 Məktəb üçün Data İnfrastruktur Quraşdırılması", Location: "İstanbul / Tuzla", Date: "2017" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Bənd Elektrifikasiyası"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Water, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Qurum"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Layihə"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Məkan"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Tarix"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Alçe Su A.Ş.", Project: "Su Səddi Elektrik İşləri", Location: "İzmir / Alaçatı", Date: "2002" })
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;